import { useContext } from 'react';

import { EnvironmentScopeContext } from '@/providers/environmentScopeContext';

export function useEnvironmentScope() {
  const context = useContext(EnvironmentScopeContext);

  if (!context) {
    throw new Error('useEnvironmentScope must be used within an EnvironmentScopeProvider');
  }

  return context;
}